export default {
  namespaced: true,
  state     : {
    breadcrumbs: [
      {
        id      : 1,
        text    : 'Главная',
        disabled: false,
      },
      {
        id      : 2,
        text    : 'Сотрудники и организации',
        disabled: true,
      },
    ],
  },
  getters: {
    breadcrumbs: ({breadcrumbs}) => breadcrumbs,
  },
};
